module.exports = __webpack_public_path__ + "img/36.7053ec42.jpg";